<template>
  <v-dialog v-model="dialog" persistent>
    <v-card>
      <!-----------------------------------------TITLE BAR----------------------------------------->
      <v-card-title class="redColor d-flex">
        <span class="headline text-white">
          {{ $t("parts.inventory.form.edit_part") }}
          {{ editId }}
        </span>
        <v-spacer />
        <v-btn variant="outlined" icon large color="white" @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <!-------------------------------------------FORM-------------------------------------------->
      <v-card-text>
        <v-form ref="form">
          <div class="container">
            <v-row>
              <!-------------------------------------SHIPMENT-------------------------------------->
              <v-col cols="12" sm="6" lg="6">
                <v-select
                  v-model="part.shipment_id"
                  :items="shipments"
                  :label="$t('parts.inventory.form.shipment')"
                  color="red-darken-1"
                  solo
                  item-title="name"
                  item-value="_id"
                  readonly
                />
              </v-col>
              <!------------------------EXTERNAL COLOR------------------------------------->
              <v-col cols="12" sm="3" lg="3">
                <v-text-field
                  v-model="externalColor"
                  :label="$t('vehicle_entry.info.external_color')"
                  variant="outlined"
                  readonly
                />
              </v-col>
              <!-------------------------------------EBAY CODE------------------------------------->
              <v-col cols="12" sm="3" lg="3">
                <v-text-field
                  v-model.trim="part.ebayCode"
                  :label="$t('parts.inventory.form.ebay_code')"
                  color="red-darken-1"
                  variant="outlined"
                  readonly
                />
              </v-col>
              <!---------------------------------------NOTES--------------------------------------->
              <v-col cols="12" sm="4" lg="4">
                <v-text-field
                  v-model="part.notes"
                  :label="$t('parts.inventory.form.notes')"
                  color="red-darken-1"
                  variant="outlined"
                  hide-details
                  readonly
                />
                <span
                  class="col-12 d-flex justify-end text-end ml-auto"
                  style="color: grey"
                >
                  {{
                    part.notes
                      ? "(" + part.notes.length + $t("characters") + ")"
                      : ""
                  }}
                </span>
              </v-col>
              <!----------------------------------------PRA---------------------------------------->
              <v-col cols="12" sm="4" lg="4">
                <v-text-field
                  v-model="part.pra"
                  :label="$t('parts.inventory.form.pra')"
                  color="red-darken-1"
                  variant="outlined"
                  readonly
                />
              </v-col>
              <!---------------------------------------BRAND--------------------------------------->
              <v-col cols="12" sm="4" lg="4">
                <v-text-field
                  v-model="part.brand"
                  :label="$t('parts.inventory.form.brand')"
                  color="red-darken-1"
                  variant="outlined"
                  readonly
                />
              </v-col>
              <!------------------------------------REPOSITORY------------------------------------->
              <v-col cols="6" lg="4">
                <v-select
                  v-model="repository"
                  :items="repositories"
                  :label="$t('parts.inventory.form.select_repository')"
                  color="red-darken-1"
                  variant="outlined"
                  item-title="name"
                  item-value="_id"
                  return-object
                  readonly
                />
              </v-col>
              <!---------------------------------------ROOM---------------------------------------->
              <v-col cols="6" lg="3">
                <v-select
                  v-model="room"
                  :items="repository.rooms"
                  :label="$t('parts.inventory.form.select_room')"
                  color="red-darken-1"
                  variant="outlined"
                  item-title="name"
                  return-object
                  readonly
                />
              </v-col>
              <!-------------------------------------LOCATION-------------------------------------->
              <v-col cols="4" lg="3">
                <v-select
                  v-model="location"
                  :items="room.locations"
                  :label="$t('parts.inventory.form.select_location')"
                  color="red-darken-1"
                  variant="outlined"
                  item-title="code"
                  return-object
                  readonly
                />
              </v-col>
              <!------------------------------------POSITION X------------------------------------->
              <v-col cols="4" lg="1">
                <v-select
                  v-model="position_x"
                  :items="pos_x"
                  :label="$t('parts.inventory.form.select_x')"
                  color="red-darken-1"
                  variant="outlined"
                  readonly
                />
              </v-col>
              <!------------------------------------POSITION Y------------------------------------->
              <v-col cols="4" lg="1">
                <v-select
                  v-model="position_y"
                  :items="pos_y"
                  :label="$t('parts.inventory.form.select_y')"
                  color="red-darken-1"
                  variant="outlined"
                  readonly
                />
              </v-col>
              <!--------------------------------------QUALITY-------------------------------------->
              <v-col cols="9">
                <div class="subheading">
                  {{ $t("parts.inventory.form.quality") }}
                </div>
                <v-radio-group v-model="part.quality" inline readonly>
                  <v-radio
                    v-for="(quality, index) in qualities"
                    :key="index"
                    :value="quality._id"
                    color="red-darken-2"
                    readonly
                  >
                    <template #label>
                      <v-rating
                        v-model="quality.rating"
                        color="amber"
                        small
                        background-color="amber"
                        readonly
                      />
                    </template>
                  </v-radio>
                </v-radio-group>
              </v-col>
              <!--------------------------------------CONDITION--------------------------------------->
              <v-col cols="1">
                <div>
                  <div>{{ $t("parts.inventory.form.condition") }}</div>
                  <v-checkbox
                    v-model="part.isNewPart"
                    :label="$t('parts.inventory.form.new')"
                    color="red-darken-3"
                    hide-details
                    class="mt-0 pt-0"
                    readonly
                  />
                </div>
              </v-col>
              <!---------------------------------------PRICE--------------------------------------->
              <v-col cols="6" sm="4">
                <v-text-field
                  v-model="part.price"
                  :label="$t('parts.inventory.form.price')"
                  variant="outlined"
                  color="red-darken-1"
                  type="number"
                  readonly
                />
              </v-col>
              <!--COST-->
              <v-col cols="6" sm="4">
                <v-text-field
                  v-model="part.cost"
                  :label="$t('parts.inventory.form.cost')"
                  color="red-darken-1"
                  variant="outlined"
                  type="number"
                  readonly
                />
              </v-col>
              <!--INFOCAR REFERENCE PRICE-->
              <v-col cols="6" sm="4">
                <v-text-field
                  v-if="part.infoCar && part.infoCar.price"
                  v-model="part.infoCar.price"
                  :label="$t('parts.inventory.form.reference_price')"
                  color="red-darken-1"
                  variant="outlined"
                  readonly
                />
                <v-text-field
                  v-else
                  :label="$t('parts.inventory.form.reference_price')"
                  color="red-darken-1"
                  variant="outlined"
                  readonly
                />
              </v-col>
              <!--CURRENCY-->
              <v-col cols="12" sm="4">
                <v-select
                  v-model="part.currency"
                  :items="currency"
                  :label="$t('parts.inventory.form.currency')"
                  color="red-darken-1"
                  variant="outlined"
                  readonly
                />
              </v-col>
              <!-------------------------------------WARRANTY-------------------------------------->
              <v-col cols="12" sm="4">
                <v-select
                  v-model="part.warranty_id"
                  :items="warranties"
                  :label="$t('parts.inventory.form.warranty')"
                  color="red-darken-1"
                  variant="outlined"
                  :item-title="() => ''"
                  item-value="_id"
                  readonly
                >
                  <template #item="{ props: itemProps, item }">
                    <v-list-item v-bind="itemProps">
                      {{ (item.raw.return_days ?? 0) / 86400 }}
                      {{ $t("warranties.days") }}
                    </v-list-item>
                  </template>
                  <template #selection="{ item }">
                    <span v-if="item">
                      {{ (item.raw.return_days ?? 0) / 86400 }}
                      {{ $t("warranties.days") }}
                    </span>
                    <span v-else>{{
                      $t("parts.inventory.form.warranty")
                    }}</span>
                  </template>
                </v-select>
              </v-col>
              <!---------------------------------MANUFACTURER CODE--------------------------------->
              <v-col cols="12" sm="4">
                <v-text-field
                  v-model="part.manufacturer_code"
                  :label="$t('parts.inventory.form.manufacturer_code')"
                  color="red-darken-1"
                  variant="outlined"
                  readonly
                />
              </v-col>
              <!---------------------------------REPLACEMENT CODES--------------------------------->
              <v-col cols="12" sm="4">
                <v-text-field
                  v-if="part.infoCar && part.infoCar.replacementCodes"
                  v-model="part.infoCar.replacementCodes"
                  :label="$t('parts.inventory.form.replacement_codes')"
                  color="red-darken-1"
                  variant="outlined"
                  readonly
                />
                <v-text-field
                  v-else
                  :label="$t('parts.inventory.form.replacement_codes')"
                  color="red-darken-1"
                  variant="outlined"
                  readonly
                />
              </v-col>

              <!------------------------------------PHOTO GRID------------------------------------->
              <v-col cols="12">
                <v-container grid-list-sm fluid>
                  <!--EXISTING PHOTOS-->
                  <v-row class="d-flex flex-nowrap" no-gutters>
                    <div
                      v-for="(image, index) in part.images"
                      :key="index"
                      class="shrink"
                    >
                      <v-img
                        :src="`https://leko-tech.fra1.cdn.digitaloceanspaces.com/${image.thumb}`"
                        width="150px"
                        class="mx-1 pointer"
                        @click="viewImage(image)"
                      />
                    </div>
                  </v-row>
                  <!--LABEL IMAGE-->
                  <v-row v-if="part.oemLableDetails" class="pa-2">
                    <h2 class="mt-4 mb-2">
                      {{ $t("parts.inventory.form.label_image") }}
                    </h2>
                    <v-col cols="12">
                      <v-img
                        :src="`https://leko-tech.fra1.cdn.digitaloceanspaces.com/${part.oemLableDetails}`"
                        width="150px"
                        class="mx-1 pointer"
                        @click="viewLabelImage"
                      />
                    </v-col>
                  </v-row>
                </v-container>
              </v-col>
            </v-row>
          </div>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn color="red-darken-1" variant="outlined" @click="close">
          {{ $t("parts.inventory.form.close") }}
        </v-btn>
      </v-card-actions>
    </v-card>

    <!-- Image viewer -->
    <img-dialog ref="imgDialog" />
  </v-dialog>
</template>

<script>
import getRequest from "../../api/getRequest";
import ImgDialog from "@/components/imgDialog.vue";

export default {
  components: {
    "img-dialog": ImgDialog,
  },
  data: () => ({
    dialog: false,
    part: {},
    externalColor: "",
    currency: ["EUR"],
    weight: { value: 0, unit: "kg" },
    warranties: [],
    shipments: [],
    qualities: [],
    repositories: [],
    repository: {},
    room: {},
    location: {},
    pos_x: [],
    pos_y: [],
    position_x: null,
    position_y: null,
  }),
  computed: {
    editId() {
      if (this.part.old_id) {
        const id = this.part.old_id;
        return id.slice(id.length - 6, id.length);
      } else if (this.part._id) {
        const id = this.part._id;
        return id.slice(id.length - 6, id.length);
      }
      return null;
    },
  },
  watch: {
    dialog(value) {
      if (value) {
        this.getWarranties();
        this.getShipments();
        this.getQualities();
        this.getRepositories();
      }
    },
  },
  methods: {
    open(data) {
      this.part = JSON.parse(JSON.stringify(data));
      this.externalColor =
        data.car && data.car.externalColor ? data.car.externalColor : "";
      if (data.weight) this.weight = data.weight;
      this.getRepository(data.repository_id);
      this.dialog = true;
    },
    close() {
      this.part = {};
      this.externalColor = "";
      this.warranties = [];
      this.shipments = [];
      this.qualities = [];
      this.repositories = [];
      this.repository = {};
      this.room = {};
      this.location = {};
      this.position_x = null;
      this.position_y = null;
      this.dialog = false;
    },
    viewImage(image) {
      this.$refs.imgDialog.open({ type: "string", data: image });
    },
    viewLabelImage() {
      this.$refs.imgDialog.open({
        type: "string",
        data: {
          image: this.part.oemLableDetails,
          thumb: this.part.oemLableDetails,
        },
      });
    },
    getWarranties() {
      getRequest("/warranty")
        .then((response) => {
          this.warranties = response.warranties;
        })
        .catch(() => {});
    },
    getShipments() {
      getRequest(
        "/shipment",
        `institution_id=${this.$store.getters.institutionId}`,
      )
        .then((response) => {
          this.shipments = response.shipments;
        })
        .catch(() => {});
    },
    getQualities() {
      getRequest("/quality")
        .then((response) => {
          this.qualities = response.qualities;
        })
        .catch(() => {});
    },
    getRepositories() {
      getRequest(
        "/repository",
        `institution_id=${this.$store.getters.institutionId}`,
      )
        .then((response) => {
          this.repositories = response.repositories;
        })
        .catch(() => {});
    },
    getRepository(repositoryId) {
      if (!repositoryId) return;
      getRequest("/repository/", `repository_id=${repositoryId}`)
        .then((response) => {
          if (response && response.repository) {
            this.repository = response.repository;
            const room = response.repository.rooms?.find(
              (r) => r._id === this.part.room_id,
            );
            if (room) {
              this.room = room;
              const loc = room.locations?.find(
                (l) => l._id === this.part.location_id,
              );
              if (loc) {
                this.location = loc;
                this.position_x = this.part.shelf_data?.shelf?.x ?? null;
                this.position_y = this.part.shelf_data?.shelf?.y ?? null;
              }
            }
          }
        })
        .catch(() => {});
    },
  },
};
</script>
